import Button from "../../../core/design-system/Button/Button";
import { Img } from "../../../core/design-system/Img";
import { Text } from "../../../core/design-system/Text";

const OpenBanking = () => {
  return (
    <div
      className=" flex flex-col w-full top-96 left-28 rounded-tl-xl border-t rounded-xl 
    border border-solid border-blue_gray-50_02 bg-[#F5F6F7] py-6 px-5 gap-8"
    >
     <div className="flex flex-col gap-6">
      <div className="flex flex-row justify-between ">
        <div className="flex flex-col items-start">
          <Text size="lg">Other Bank Portfolio</Text>
          <Text size="md" className="text-gray-500">
            Last updated on: 05 Aug 2024, 10:32am
          </Text>
        </div>
        <button className="w-9 h-9 pt-2 gap-2 rounded-lg border opacity-0 bg-white-A700">
          <Img src="refresh-cw-04.svg" alt="refresh" className="w-6 h-6" />
        </button>
      </div>
      <Img
        src="progressBar.svg"
        alt="progressBar"
        className="w-full object-cover"
      />
      <div className="flex flex-row ">
        <div className="w-1/2 flex flex-row gap-2">
          <Img
            src="aub-Ellipse-primary.svg"
            alt="refresh"
            className="w-3 h-3 mt-2"
          />
          <div className="flex flex-col items-start">
            <Text size="md" className="text-[#667085]">
              Total Assets
            </Text>
            <Text size="xl"> BHD 41,673.870</Text>
          </div>
        </div>
        <div className="w-1/2 flex flex-row gap-2">
          <Img
            src="aub-Ellipse-secondary.svg"
            alt="refresh"
            className="w-3 h-3 mt-2"
          />
          <div className="flex flex-col items-start">
            <Text size="md" className="text-[#667085]">
              Total Liabilities
            </Text>
            <Text size="xl"> BHD 18,572.710</Text>
          </div>
        </div>
      </div>
      </div>
      <div className="flex flex-row justify-items-start">
        <Button
          className="bg-white-A700 text-[#344054] gap-11 border border-gray-500"
          size="default"
          onClick={() => {}}
        >
          View Details
          <Img src="arrow-right.svg" alt="arrow-right" className="w-4 h-4 rounded-lg" />
        </Button>
      </div>
    </div>
  );
};

export default OpenBanking;
